import React from 'react';

const Stat = ({ label, value, testId }) => (
  <div className="bg-card border border-border rounded p-5" data-testid={testId}>
    <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">{label}</p>
    <p className="text-2xl font-bold text-foreground mt-1">{value}</p>
  </div>
);

const ProjectStatsGrid = ({ totalHours, totalMachineHours, etaCount, signatureCount, costSummary }) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
    <Stat
      label="Totala timmar"
      value={(costSummary?.labor_hours ?? totalHours).toFixed(1)}
      testId="project-stat-hours"
    />
    <Stat
      label="Maskintimmar"
      value={(costSummary?.machine_hours ?? totalMachineHours).toFixed(1)}
      testId="project-stat-machine-hours"
    />
    <Stat label="ÄTA-rapporter" value={etaCount} testId="project-stat-eta" />
    <Stat label="Signaturer" value={signatureCount} testId="project-stat-signatures" />
  </div>
);

export default ProjectStatsGrid;
